 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~EshopLeasingCatalogue","52":"vendors~GECheckUsageWidget","53":"vendors~GERoiForm","54":"vendors~PickAndGoWidget","55":"vendors~PricePlanCards","56":"vendors~PromotionsWidget","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"c807302d","1":"b591394d","2":"d2d976ef","3":"cd076d1e","4":"1841887e","5":"5e3ddf43","6":"2b5df33e","7":"f9fb1147","8":"5df0fb5a","9":"70e779f6","10":"16b51904","11":"05f42813","12":"0718fe25","13":"171d454d","14":"bbf0708f","15":"8b41aa1c","16":"aa9661bc","17":"e4b35d5e","18":"c08b96b8","19":"13d25c27","20":"5d73f35c","21":"9b406e57","22":"d26dabf7","23":"66bf4025","24":"f1e9d534","25":"29c66a5c","26":"98367611","27":"7729a965","28":"ebaa4715","29":"93fe7a8f","30":"b084282d","31":"decf83ca","32":"dddb670f","33":"c829ad35","34":"8997de48","35":"901f1761","36":"226bb36f","37":"b32ffd70","38":"33e7d2be","39":"c3c7e293","40":"aebf8a59","41":"16f3ebe9","42":"7e0bdf05","43":"56c40a86","44":"31d28fab","45":"7b0fa696","46":"aa70a818","47":"d8e425dd","50":"eb4852a9","51":"12b22719","52":"e0c43ccf","53":"35c266d7","54":"e52f844a","55":"9c06a8d7","56":"390e605d","57":"83e4f392","58":"57517be8","59":"1c87b0d5","60":"c5083d81","61":"d502dcb2","62":"dc48e0e9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"38":1,"55":1,"60":1,"61":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~EshopLeasingCatalogue","52":"vendors~GECheckUsageWidget","53":"vendors~GERoiForm","54":"vendors~PickAndGoWidget","55":"vendors~PricePlanCards","56":"vendors~PromotionsWidget","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"c807302d","1":"b591394d","2":"d2d976ef","3":"cd076d1e","4":"1841887e","5":"5e3ddf43","6":"2b5df33e","7":"f9fb1147","8":"5df0fb5a","9":"70e779f6","10":"16b51904","11":"05f42813","12":"0718fe25","13":"171d454d","14":"bbf0708f","15":"8b41aa1c","16":"aa9661bc","17":"e4b35d5e","18":"c08b96b8","19":"13d25c27","20":"5d73f35c","21":"9b406e57","22":"d26dabf7","23":"66bf4025","24":"f1e9d534","25":"29c66a5c","26":"98367611","27":"7729a965","28":"ebaa4715","29":"93fe7a8f","30":"b084282d","31":"decf83ca","32":"dddb670f","33":"c829ad35","34":"8997de48","35":"901f1761","36":"226bb36f","37":"b32ffd70","38":"33e7d2be","39":"c3c7e293","40":"aebf8a59","41":"16f3ebe9","42":"7e0bdf05","43":"56c40a86","44":"31d28fab","45":"7b0fa696","46":"aa70a818","47":"d8e425dd","50":"eb4852a9","51":"12b22719","52":"e0c43ccf","53":"35c266d7","54":"e52f844a","55":"9c06a8d7","56":"390e605d","57":"83e4f392","58":"57517be8","59":"1c87b0d5","60":"c5083d81","61":"d502dcb2","62":"dc48e0e9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.aws.singtel.com/lux/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
